const APIURL = "https://digiaussie.com.au/apps/digiproxy";

const checkForCashback = (customerId, customerName, maxValue) => {
  fetch(`${APIURL}/public/customers/points/${customerId}`)
  .then((res) => res.json())
  .then((data) => {
    
    // Add custom styling
    let css = '#cashback-container {margin-top: 20px;} .price-box-da{margin-top:10px;font-weight:700;border:2px solid #000;min-width:75px;padding:5px;float:left;text-align:center;margin-right:10px;cursor:pointer;border-radius:3px}',
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');
    head.appendChild(style);
    style.type = 'text/css';
    if (style.styleSheet){
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    

    
    // Add cashback div
    const cashback = data.data.points;
    const priceDiv = document.createElement("div");
    const newDiv = document.createElement("div");
    newDiv.id = "cashback-container";
    newDiv.appendChild(document.createTextNode(`Thanks for being a loyal customer, ${customerName}! You have earned $${cashback.toFixed(2)} in cashback. Select how much you want to redeem (Minimum $10 spend):`));
    
    if (cashback > 0) {
      for (let i = 5; i <= cashback; i += 5) {
          const newPriceButton = document.createElement("div");
          newPriceButton.classList.add("price-box-da");
          newPriceButton.appendChild(document.createTextNode(`$${i}`));
          newPriceButton.dataset.value = i;
          priceDiv.appendChild(newPriceButton);
      }
      
      const newPriceButton = document.createElement("div");
      newPriceButton.classList.add("price-box-da");
      newPriceButton.appendChild(document.createTextNode(`ALL`));
      newPriceButton.dataset.value = cashback > (maxValue/100) ? (maxValue/100) : cashback;
      priceDiv.appendChild(newPriceButton);
      newDiv.append(priceDiv)

      const checkoutButton = document.getElementsByClassName("cart-list")[0];
      checkoutButton.insertAdjacentHTML("afterend", newDiv.outerHTML);
		
      (function($){
          $(".price-box-da").on("click", function() {
              const val = $(this).data("value");
             $("#cashback-container").html('Please wait while we add your cashback to your cart.');
              fetch(`${APIURL}/public/customers/createVoucher/${customerId}/${val}`)
                  .then((res) => res.json())
                  .then((cashbackData) => {
                      const discountCode = cashbackData.data.discount;
                	  window.location.assign(`/discount/${discountCode}?redirect=/checkout`)
                  })
          })
      })(jQuery);
    }
  })
  .catch(() => null)
}